
import * as React from 'react';
import PropTypes from 'prop-types';

import { Dropdown, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faPencilAlt, faTrashAlt, faSearch } from '@fortawesome/pro-solid-svg-icons';

import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';

import { clickAsLink } from 'helpers/link_helpers';

import Details from './details';

export default function Item({ requirement, onDelete }) {
  const handleSearchProperties = (e) => {
    clickAsLink(window, requirement.searchPath, e);
  };

  const handleEditRequirement = (e) => {
    clickAsLink(window, requirement.editPath, e);
  };

  const renderDropdown = () => {
    return (
      <Dropdown className="pull-right" id="requirements-action-dropdown">
        <UnstyledDropdownToggle
          bsRole="toggle"
          className="right-buffer-md"
        >
          <FontAwesomeIcon className="assignments-gear" icon={faCog}/>
        </UnstyledDropdownToggle>
        <Dropdown.Menu className="assignments-dropdown">
          <MenuItem
            className="pl-3"
            eventKey={1}
            name="edit-btn"
            onClick={e => handleEditRequirement(e)}
          >
            <FontAwesomeIcon className="dropdown-icons" icon={faPencilAlt}/>
            Edit Requirement
          </MenuItem>
          <MenuItem
            className="pl-3"
            eventKey={2}
            name="search-btn"
            onClick={e => handleSearchProperties(e)}
          >
            <FontAwesomeIcon className="dropdown-icons" icon={faSearch}/>
            Search for matching Properties
          </MenuItem>
          <MenuItem
            className="pl-3"
            eventKey={3}
            name="delete-btn"
            onClick={() => onDelete(requirement)}
          >
            <FontAwesomeIcon className="dropdown-icons" icon={faTrashAlt}/>
            Delete Requirement
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <React.Fragment>
      <div className="h5 mt-0">
        <a href={requirement.searchPath}>
          <strong>{requirement.name}</strong>
        </a>

        {renderDropdown()}
      </div>
      <Details requirement={requirement} />
    </React.Fragment>
  );
}

Item.propTypes = {
  requirement: PropTypes.shape({
    buildingSize: PropTypes.string,
    editPath: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    leaseDate: PropTypes.string,
    lotSize: PropTypes.string,
    name: PropTypes.string.isRequired,
    notes: PropTypes.string,
    numberOfUnits: PropTypes.string,
    propertyTypes: PropTypes.string,
    salePrice: PropTypes.string,
    searchPath: PropTypes.string.isRequired,
    transactionType: PropTypes.string.isRequired
  }).isRequired,
  onDelete: PropTypes.func.isRequired
};
